
  import SecureLS from "secure-ls";
  export default {
    components: {
      Actions: () => import("~/components/product_info/application/Actions"),
      Breadcrumbs: () => import("~/components/global/Breadcrumbs"),
    },
    data: () => ({
      payload: null,
      last_step: 0,
      loaded: false,
      addresses: [],
      modal: false,
      confirmLeave: false,
    }),
    beforeRouteLeave (to, from, next)
    {
      let ls = new SecureLS();
      setTimeout(() =>
      {
        if (this.$refs.wizard && this.$refs.wizard.active_step <= this.last_step)
        {
          let url = to.fullPath,
            f_url = null;
          if (
            url ==
            "/products/assets-and-property/automaster/application/manual-quotation/"
          )
          {
            window.location.replace(window.location.origin + url);
          } else
          {
            this.modal = true;
            if (url.endsWith("/"))
            {
              let url_chk = url.replace(/.$/, "");
              f_url = url_chk ? url_chk : url;
            } else
            {
              f_url = url;
            }
            this.confirmLeave = f_url;
          }
        } else
        {
          this.removeLS();
          next();
        }
      }, 50);
    },
    methods: {
      confirmLeaveUnsavedData ()
      {
        this.confirmLeave = true;
      },
      leaving (event)
      {
        let ls = new SecureLS();
        if (performance.navigation.type == 1)
        {
          if (this.$refs.wizard && this.$refs.wizard.active_step <= this.last_step)
          {
            ls.remove("__images__");
          } else
          {
            this.removeLS();
          }
        }
      },
      getProductDirectory ()
      {
        switch (this.$route.params.product)
        {
          case "travel-master":
          case "travel-lite":
            this.payload.dirs = {
              step_one: "lifestyle/travel-master-lite/StepOne.vue",
              step_two: "lifestyle/travel-master-lite/StepTwo.vue",
              step_three: "lifestyle/travel-master-lite/StepThree.vue",
              certify: "I certify that all information are true and correct.",
              receipt: true,
            };
            this.payload.active_dirs = {
              step_one: 0,
              step_two: 1,
              step_three: 2,
              step_four: 3,
              privacy: 0,
              receipt: 0,
              last_confirmation: 2,
              privacy_updates: false,              
            };
            this.last_step = 4;
            this.payload.active_step = 0;
            this.payload.last_step = 4;
            this.payload.total_step = 5;
            this.payload.steps = [
              {
                name: "Quotation Form",
                active: true,
                finished: false,
              },
              {
                name: "Packages",
                active: false,
                finished: false,
              },
              {
                name: "Personal Details",
                active: false,
                finished: false,
              },
              {
                name: "Summary",
                active: false,
                finished: false,
              },
              {
                name: "Confirmation",
                active: false,
                finished: false,
              },
            ];
            break;
          case "vital-cover":
            this.payload.dirs = {
              step_three: "personal-family/StepThree.vue",
              receipt: true,
            };
            this.payload.active_dirs = {
              step_three: 0,
              step_four: 1,
              privacy: 0,
              receipt: -1,
            };
            this.last_step = 2;
            this.payload.active_step = 0;
            this.payload.last_step = 2;
            this.payload.total_step = 3;
            this.payload.steps = [
              {
                name: "Personal Details",
                active: true,
                finished: false,
              },
              {
                name: "Summary",
                active: false,
                finished: false,
              },
              {
                name: "Confirmation",
                active: false,
                finished: false,
              },
            ];
            break;
          case "my-wellness":
          case "dengue-cash":
          case "renters-protect":
          case "househelp-protect":
          case "family-relief":
          case "i4u":
            switch (this.$route.params.product)
            {
              case "i4u":
                this.payload.dirs = {
                  step_one: "personal-family/StepOne.vue",
                  step_two: "StepTwo.vue",
                  step_three: "personal-family/i4u/StepThree.vue",
                  receipt: true,
                };
                this.last_step = 3;
                this.payload.last_step = 3;
                break;
              default:
                this.payload.dirs = {
                  step_one: "personal-family/StepOne.vue",
                  step_two: "StepTwo.vue",
                  step_three: "personal-family/StepThree.vue",
                  receipt: true,
                };
                this.last_step = 3;
                this.payload.last_step = 3;
            }
            this.payload.active_dirs = {
              step_one: 0,
              step_two: 1,
              step_three: 2,
              step_four: 3,
              privacy: 2,
              receipt: 0,
            };
            this.last_step = 4;
            this.payload.active_step = 0;
            this.payload.last_step = 4;
            this.payload.total_step = 5;
            this.payload.steps = [
              {
                name: "Quotation Form",
                active: true,
                finished: false,
              },
              {
                name: "Packages",
                active: false,
                finished: false,
              },
              {
                name: "Personal Details",
                active: false,
                finished: false,
              },
              {
                name: "Summary",
                active: false,
                finished: false,
              },
              {
                name: "Confirmation",
                active: false,
                finished: false,
              },
            ];
            break;
          case "fire-and-lightning":
          case "home-protect-lite":
          case "home-protect":
          case "automaster":
          case "automaster-compre":
          case "motoone":
            switch (this.$route.params.product)
            {
              case "automaster":
              case "automaster-compre":
                this.payload.dirs = {
                  step_one: "assets-and-property/StepOne.vue",
                  step_two: "assets-and-property/StepTwo.vue",
                  step_three: "assets-and-property/StepThree.vue",
                  receipt: true,
                  certify: "I certify that all information are true and correct.",
                };
                break;
              case "motoone":
                this.payload.dirs = {
                  step_one: "assets-and-property/motoone/StepOne.vue",
                  step_two: "assets-and-property/motoone/StepTwo.vue",
                  step_three: "assets-and-property/motoone/StepThree.vue",
                  certify: "I certify that all information are true and correct.",
                  receipt: true,
                };
                break;
              case "fire-and-lightning":
              case "home-protect-lite":
                this.payload.dirs = {
                  step_one: "assets-and-property/fire-and-lightning/StepOne.vue",
                  step_two: "assets-and-property/home-protect/StepTwo.vue",
                  step_three: "assets-and-property/home-protect/StepThree.vue",
                  receipt: true,
                };
                break;
              case "home-protect":
                this.payload.dirs = {
                  step_one: "assets-and-property/home-protect/StepOne.vue",
                  step_two: "assets-and-property/home-protect/StepTwo.vue",
                  step_three: "assets-and-property/home-protect/StepThree.vue",
                  certify: "I certify that all information are true and correct.",
                  receipt: true,
                };
                break;
            }
            this.payload.active_dirs = {
              step_one: 0,
              step_two: 1,
              step_three: 2,
              step_four: 3,
              privacy: 0,
              receipt: 0,
              last_confirmation: 2,
              privacy_updates: false,
            };
            this.last_step = 4;
            this.payload.active_step = 0;
            this.payload.last_step = 4;
            this.payload.total_step = 5;
            this.payload.steps = [
              {
                name: "Quotation Form",
                active: true,
                finished: false,
              },
              {
                name: "Packages",
                active: false,
                finished: false,
              },
              {
                name: "Personal Details",
                active: false,
                finished: false,
              },
              {
                name: "Summary",
                active: false,
                finished: false,
              },
              {
                name: "Confirmation",
                active: false,
                finished: false,
              },
            ];
            break;
          case "pet-insurance":
            this.payload.dirs = {
              step_two: "assets-and-property/pet-insurance/StepTwo.vue",
              step_three: "assets-and-property/pet-insurance/StepThree.vue",
              certify: "I certify that all information are true and correct.",
              receipt: true,
            };
            this.payload.active_dirs = {
              step_two: 0,
              step_three: 1,
              step_four: 2,
              privacy: 0,
              receipt: 0,
              last_confirmation: 2,
            };
            this.last_step = 3;
            this.payload.active_step = 0;
            this.payload.last_step = 3;
            this.payload.total_step = 4;
            this.payload.steps = [
              {
                name: "Pet Details",
                active: true,
                finished: false,
              },
              {
                name: "Personal Details",
                active: false,
                finished: false,
              },
              {
                name: "Summary",
                active: false,
                finished: false,
              },
              {
                name: "Confirmation",
                active: false,
                finished: false,
              },
            ];
            break;
          default:
            alert("Selected Packages are not Available");
        }
      },
      getDataList ()
      {
        let ls = new SecureLS(),
          provinces = ls.get("__province__"),
          ids = ls.get("__ids__"),
          occupations = ls.get("__occupations__");
        if (!provinces)
        {
          this.$axios.$get("web/address/province").then(({res}) =>
          {
            ls.remove("__province__");
            ls.set("__province__", JSON.stringify(res));
          });
        }
        if (!ids)
        {
          let form_data = new FormData();
          form_data.append("data[]", "ids");

          this.$axios.$post("web/data-list", form_data).then(({dataList}) =>
          {
            ls.remove("__ids__");
            ls.set("__ids__", JSON.stringify(dataList.ids));
          });
        }
        if (!occupations)
        {
          let form_data = new FormData();
          form_data.append("data[]", "occupations");

          this.$axios.$post("web/data-list", form_data).then(({dataList}) =>
          {
            ls.remove("__occupations__");
            ls.set("__occupations__", JSON.stringify(dataList.occupations));
          });
        }
      },
      removeLS ()
      {
        let ls = new SecureLS();
        ls.remove("__product__");
        ls.remove("__images__");
        ls.remove("__step__");
        ls.remove("__province__");
        ls.remove("__occupations__");
        ls.remove("__ids__");
        ls.remove("__privacy__");
        ls.remove("__promo__");
        ls.remove("__step_one__");
        ls.remove("__packages__");
        ls.remove("__selected_package__");
        ls.remove("__selected_package_addon__");
        ls.remove("__quote__");
        ls.remove("__step_three__");
      },
    },
    mounted ()
    {
      let ls = new SecureLS();
      this.toggleModalStatus({type: 'loader', status: true})
      this.$axios
        .$get(`web/products/${ this.$route.params.product }`)
        .then(({res}) =>
        {
          if (ls.get("__product__"))
          {
            if (ls.get("__product__") != this.$route.params.product)
            {
              this.removeLS();
              ls.set("__product__", this.$route.params.product);
            }
          } else
          {
            ls.set("__product__", this.$route.params.product);
          }
          this.payload = res.product;
          this.getProductDirectory();
          this.getDataList();
        })
        .catch((err) =>
        {
          error({statusCode: 500, message: "Something Went Wrong"});
        })
        .then(() =>
        {
          setTimeout(() =>
          {
            this.loaded = true;
            this.leaving();
          }, 150);
        });
    },
  };
